import { call, put, takeLatest } from "redux-saga/effects";
import { createRequest, getError } from "Utils/requestUtils";
import { DomainStatus, OperationType } from "./interfaces";
import {
  fetchDowntimeStart,
  fetchDowntimeSucceeded,
  operationFailed,
} from "./slice";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { AxiosResponse } from "axios";
import { DOWNTIME_RESOURCE_ROOT } from "Utils/apiUtils";

export function* fetchDowntime() {
  try {
    const url = DOWNTIME_RESOURCE_ROOT;
    const { data }: AxiosResponse<DomainStatus> = yield call(createRequest, {
      method: "get",
      url,
    });

    yield put(fetchDowntimeSucceeded(data));
  } catch (e) {
    yield put(
      operationFailed({
        operationType: OperationType.FETCH_DOWNTIME,
        response: getError(e),
      }),
    );
  }
}

export function* downtimeSaga(): Generator {
  yield takeLatest(fetchDowntimeStart, fetchDowntime);
}
